import type { PropsWithChildren } from 'react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type TabPanelProps = PropsWithChildren<{
  hidden: boolean;
  className?: string;
}>;

export const TabPanel: React.FC<TabPanelProps> = ({ children, hidden, className }) => {
  return (
    <div
      hidden={hidden}
      className={twMerge(
        'flex items-center w-full flex-col justify-center py-4',
        hidden && 'hidden',
        className,
      )}
    >
      {children}
    </div>
  );
};
